module.exports = __webpack_public_path__ + "img/reports.83bd14cb.svg";